const isEnglishLanguage = (): boolean => {
  if (typeof navigator === 'undefined') {
    return true
  }
  const language = navigator.language.toLowerCase()
  return language.includes('en-us') || language.includes('en-gb')
}

export default isEnglishLanguage
